import React, {useState} from 'react'
import {ExtraPickupFormBlockProps} from './types'
import {useTranslation} from 'react-i18next'
import Modal from '@sharedComponents/Modal'
import Button from '@sharedComponents/Button'
import {ButtonType} from '@sharedComponents/Button/types'
import ExtraPickupForm from './ExtraPickupForm/ExtraPickupForm'
import {IExtraPickupFormBody} from '@apps/Shared/Services/Pickups/interfaces'
import PickupsService from '@apps/Shared/Services/Pickups'
import {StatusCode} from '@apps/Shared/Services/Response.types'

const ExtraPickupFormBlock = (props: ExtraPickupFormBlockProps) => {
    const {t} = useTranslation()
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [requestErrors, setRequestErrors] = useState<any>({})
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false)
    const [resetFormToggle, setResetFormToggle] = useState<boolean>(false)

    const resetRequestErrors = () => {
        setRequestErrors({})
    }

    const hideConfirmation = () => {
        setShowConfirmation(false)
        resetRequestErrors()
    }

    const onSubmit = (postBody: IExtraPickupFormBody) => {
        setSubmitting(true)
        PickupsService.SubmitExtraPickupViaForm(postBody)
            .then(result => {
                if (result.status === StatusCode.OK) {
                    resetRequestErrors()
                    setShowConfirmation(true)
                    setResetFormToggle(!resetFormToggle)
                } else if (result.status === StatusCode.BAD_REQUEST) {
                    const errors = result?.data?.errors
                    let errorMessages: string[] = []
                    for (const key in errors) {
                        errorMessages = errorMessages.concat(errors[key])
                    }
                    console.log(errorMessages)
                    setRequestErrors({
                        ...requestErrors,
                        submit: errorMessages,
                    })
                } else {
                    const errorMessages = result.data.message
                    console.log(errorMessages)
                    setRequestErrors({
                        ...requestErrors,
                        submit: errorMessages,
                    })
                }
                setSubmitting(false)
            })
            .catch(error => {
                setSubmitting(false)
                console.log(error)
            })
    }

    return (
        <div className={'extra-pickup-form-block'}>
            {props.heading ? <h2>{props.heading}</h2> : <></>}
            <ExtraPickupForm
                onSubmit={onSubmit}
                submitting={submitting}
                requestErrors={requestErrors?.submit || []}
                resetFormToggle={resetFormToggle}
            />
            <Modal open={showConfirmation} handleClose={hideConfirmation}>
                <div className={'extra-pickup-form-block__confirmation'}>
                    <div dangerouslySetInnerHTML={{__html:props.confirmationText}}/>
                    <Button
                        text={t('button.close')}
                        type={ButtonType.PRIMARY}
                        onClick={hideConfirmation}
                    />
                </div>
            </Modal>
        </div>
    )
}

export default ExtraPickupFormBlock
